import React from 'react';
import {
  TransactionAccountProduct,
  InvoiceGroupProduct,
  EntitlementDetails,
  LinkedDestinationEntitlement,
  CloudSubscription,
} from '@css-xp/graphtypes/src/generated-types-new';
import { getNextBillOrEndDate, isAnnualTermedSubscription } from '@atlassian/cssxp-utils-entitlement';
import { ENABLE_ANNUAL_TERMS } from '@atlassian/cssxp-utils-generic';
import { NEW_DATE_FORMAT, CloudChildProduct } from '@atlassian/cssxp-typescommon';
import { NoDataContentInTable } from '../../../no-data-content-table';
import { FormattedDate } from '../../../formatted';
import { NewBillDate } from '../../../new-bill-date';
import { isActiveSubscription } from '../utils';
import { useFeatureToggle } from '../../../hooks';

interface Props {
  item:
    | LinkedDestinationEntitlement
    | InvoiceGroupProduct
    | TransactionAccountProduct
    | CloudSubscription
    | CloudChildProduct;
}

export const NextBillExpiryDate = ({ item }: Props) => {
  const [isEnabled] = useFeatureToggle();
  const isAnnualTermEnabled = isEnabled(ENABLE_ANNUAL_TERMS);
  if (!isActiveSubscription(item?.billingStatus, item?.provisioningStatus)) return <NoDataContentInTable />;
  if (item.trial) {
    if (item?.trialEndDate) {
      return (
        <div data-testid="trial-date">
          <FormattedDate date={item?.trialEndDate} format={NEW_DATE_FORMAT} />
          {!isAnnualTermedSubscription(item, isAnnualTermEnabled) && (
            <NewBillDate entitlement={item as EntitlementDetails} />
          )}
        </div>
      );
    }
    return <NoDataContentInTable />;
  }
  const nextBillOrEndDate = getNextBillOrEndDate(item, isAnnualTermEnabled);

  if (nextBillOrEndDate) {
    return (
      <div data-testid="latest-period-end-date">
        <FormattedDate date={nextBillOrEndDate} format={NEW_DATE_FORMAT} />
        {!isAnnualTermedSubscription(item, isAnnualTermEnabled) && (
          <NewBillDate entitlement={item as EntitlementDetails} />
        )}
      </div>
    );
  }
  return <NoDataContentInTable />;
};
